module.exports = __webpack_public_path__ + "static/media/effect_05.c01743a1.png";